export default __webpack_public_path__ + "static/media/AutoJoinDisableDark.9a9b5811.svg";